<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="demo-modal" v-if="is_demo && display_demo_popup">
      <div class="demo-content">
        <div style="font-weight: bold;">
          <h3 style="margin: 10px 0px 15px 0px">데모페이지에 오신걸 환영 합니다.</h3>
          <p style="padding: 0 0 10px;">접속 아이디 <span style="color: red;">user</span></p>
          <p style="padding: 0 0 10px;">접속 비밀번호 <span style="color: red;">0000</span></p>
          <p style="padding: 0 0 10px;">사용 방법은 공지사항을 필독 해 주세요.</p>
          <p style="padding: 0 0 10px;">문의 사항은 02-6974-0888 로 연락 주시면,</p>
          <p style="padding: 0 0 10px;">친절히 안내 드리겠습니다.</p>
          <div style="border-top: solid 1px #ccc;position: absolute;width: 100%;left:0px;padding: 10px 0px;background-color: #242424;text-align: right;">
            <span style="color: #fff;padding: 10px 15px;cursor: pointer;" @click="display_demo_popup = false">Close</span>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <div class="flex flex-wrap justify-between mb-4">
                    <h4 v-text="'ZenCRM'"></h4>
                    <i18n />
                  </div>

                  <p>Welcome back, please login to your account.</p>
                </div>

                <div>
                  <vs-input
                      name="username"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      :placeholder="$t('id')"
                      v-model="loginForm.username"
                      :danger="loginFormErrors.username ? true : false"
                      :danger-text="loginFormErrors.username ? loginFormErrors.username[0] : null"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                      @keyup.enter="login"
                      class="w-full"/>

                  <vs-input
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      :placeholder="$t('password')"
                      v-model="loginForm.password"
                      :danger="loginFormErrors.password ? true : false"
                      :danger-text="loginFormErrors.password ? loginFormErrors.password[0] : null"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                      @keyup.enter="login"
                      class="w-full mt-6" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-button id="loginButton" class="float-right" @click.prevent="login" v-text="$t('login')"></vs-button>
                  </div>

                  <vs-divider></vs-divider>

                  <div class="flex flex-wrap justify-between mt-4">
                    <vs-radio v-model="loginForm.loginType" vs-value="0">{{ $t('consultant') }}</vs-radio>
                    <vs-radio v-model="loginForm.loginType" vs-value="1">{{ $t('crm_only') }}</vs-radio>
                  </div>

                  <vs-divider></vs-divider>

                  <div class="text-center mt-4">
                    <div v-if="is_demo">
                      <center>
                        ZENCRM
                        데모 페이지 입니다.<br>
                        <span style="color:red;"><b>아이디 : user<br>
                        비밀번호 : 0000</b></span><b>
                        </b>
                        <br>
                        로그인 하시면 됩니다.
                        <br>
                      </center>
                    </div>
                    <div v-else>
                      <p>Copyrights ⓒ BitWave Inc. All Rights Reserved Powered by Ziotes.</p>
                      <p class="mt-2">「 이 페이지는 1920*1080 해상도에서 최적으로 이용가능 합니다. 」</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import I18n from '@/layouts/components/navbar/components/I18n'
import httpLogin from '@/requests/httpLogin'
import UserHelper from '@/helpers/user'

export default{
  components: {
    I18n
  },
  data () {
    return {
      loginForm: {
        username: '',
        password: '',
        loginType: 0 // 0 = Consultant | 1 = CRM Only,
        // language: localStorage.getItem('language') !== null ? localStorage.getItem('language') : 'en' // TODO: Put this on I18n.vue
      },
      loginFormErrors: {},
      is_demo: typeof this.$route.query.demo !== 'undefined',
      display_demo_popup: true
    }
  },
  methods: {
    async login () {
      try {
        this.$vs.loading({background: 'primary', color: '#fff', container: '#loginButton', scale: 0.45})

        // TODO: Add Login Success Alert
        const response = await httpLogin.post('login', this.loginForm)

        const userData = new UserHelper(response)
        await this.$store.dispatch('setToken', userData.getAccessToken())
        await this.$store.dispatch('setRefreshToken', userData.getRefreshToken())
        await this.$store.dispatch('setUserInfo', userData.getUserData())

        window.location.replace(userData.getRedirectUrl())
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })

        this.loginFormErrors = errors.validationErrors

        this.$vs.loading.close('#loginButton > .con-vs-loading')
      }
    },
    forgotPassword () {

    }
  }
}
</script>

<style lang="scss">
.demo-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #0e0e0ead;
  z-index: 9999;
}
.demo-content {
   width: 400px;
   height: 245px;
   position: absolute;
   left: 50%;
   top: 50%;
   margin-left: -200px;
   margin-top: -150px;
   background-color: #fff;
   padding: 10px;
}
</style>
